import { DEBUG } from "../../../../config";
import { globalDexieDb } from "../DexiedbLib";
import { DataCanChuyenResult, DataCanChuyenStruct, SttStruct } from "./canchuyen";

export function GetRedisKeyGiuLaiChungByLoaiCuocId(contactId: number, dai: string, loaiCuocId: string, mienCuPhapId: number): [string, string, string] {
    let result: string = "";
    let group: string = "";
    let subGroup: string = "";
    switch (loaiCuocId) {
        case "Lo2C":
        case "6Lo2C":
        case "7Lo2C":
        case "8Lo2C":
            group = "2C";
            subGroup = "LO";
            break;
        case "Lo3C":
        case "6Lo3C":
        case "7Lo3C":
            group = "3C";
            subGroup = "LO";
            break;
        case "DaX":
        case "DaT":
        case "Xi2":
        case "Xi3":
        case "Xi4":
            group = "Da";
            subGroup = "Da";
            let tmp: string = loaiCuocId;
            if (mienCuPhapId === 1) {
                group = "Xien";
                switch (tmp) {
                    case "Xi2":
                        subGroup = "Xi2";
                        break;
                    case "Xi3":
                        subGroup = "Xi3";
                        break;
                    case "Xi4":
                        subGroup = "Xi4";
                        break;
                }
            }
            break;
        case "Xi2A":
        case "Xi3A":
        case "Xi4A":
            group = "XienA";
            subGroup = loaiCuocId;
            break;
        case "Dau2C":
            group = "2C";
            subGroup = "DAU";
            break;
        case "Dau4C":
            group = "4C";
            subGroup = "DAU";
            break;
        case "Duoi2C":
            group = "2C";
            subGroup = "DUOI";
            break;
        case "Duoi4C":
            group = "4C";
            subGroup = "DUOI";
            break;
        case "Lo4C":
            group = "4C";
            subGroup = "LO";
            break;
        case "XcDuoi":
        case "XC":
            group = "3C";
            subGroup = "DUOI";
            break;
        case "XcDau":
            group = "3C";
            subGroup = "DAU";
            break;
        case "3c":
            group = "3Cang";
            subGroup = "3c";
            break;
        case "3cA":
            group = "3Cang";
            subGroup = "3cA";
            break;
        case "3c1":
            group = "3Cang";
            subGroup = "3c1";
            break;
        case "3c1A":
            group = "3Cang";
            subGroup = "3c1A";
            break;
        case "De":
            group = "De";
            subGroup = "De";
            break;
        case "DeA":
            group = "DeA";
            subGroup = "DeA";
            break;
        case "Giai2":
            group = "Giai2";
            subGroup = "Giai2";
            break;
        case "Giai3":
            group = "Giai2";
            subGroup = "Giai3";
            break;
        case "Lo":
            group = "Lo";
            subGroup = "Lo";
            break;
        case "LoA":
            group = "LoA";
            subGroup = "LoA";
            break;
        case "Giai1":
            group = "Giai1";
            subGroup = "Giai1";
            break;
        case "Giai1A":
            group = "Giai1A";
            subGroup = "Giai1A";
            break;
        default:
            console.log("loại cược map không có, hãy bổ xung " + loaiCuocId);
    }
    let redisKey: string = GetRedisKeyGiuLaiChung(contactId, dai, group, subGroup);
    return [redisKey, group, subGroup];
}

export function GetRedisKeyGiuLaiChung(contactId: number, dai: string, group: string, subGroup: string): string {
    // glx: giu lai chung
    let result: string = `${contactId}:${dai}:${group}:${subGroup}`;
    return result;
}
//Key giứ lại chung
export function GetKeyForCanChuyenParamGroup(contactId: number, dai: string, loaiCuocId: string, mienCuPhapId: number):
    [number, string, string, string, number] {
    const [rediskey, group, subgroup] = GetRedisKeyGiuLaiChungByLoaiCuocId(contactId, dai, loaiCuocId, mienCuPhapId);
    return [contactId, dai, group, subgroup, mienCuPhapId]
}
export async function FillGiuLaiChung(contactId: number, mienCuPhapId: number, data: DataCanChuyenStruct,
    result: DataCanChuyenResult) {
    const keys = GetKeyForCanChuyenParamGroup(contactId, data.daiId1, data.loaiCuocId, mienCuPhapId)
    const found = await globalDexieDb.canChuyenParamGroup.get(keys)
    if (found) {
        data.kieuGiu = found.kieuGiu
        data.diemGiu = found.diemGiu
        data.max = found.max
        data.min = found.min
        if (data.kieuGiu === "STT") {
            //log lại cho client biết loại cược này giữ theo điểm của bộ số có stt=n
            // xử lý tại client phần tính toán
            const sttStruct: SttStruct = { stt: data.diemGiu, loaiCuocId: data.loaiCuocId };
            if (result.foundStt == null) {
                result.foundStt = {};
            }
            result.foundStt[data.loaiCuocId] = sttStruct;
        }

    } else {
        if (DEBUG)
            console.log("FillGiuLaiChung:canChuyenParamGroup not found", keys);
    }
}